import React from 'react';
import { LucideIcon } from 'lucide-react';

interface LandlordStatCardProps {
    title: string;
    value: string | number;
    subtitle?: string;
    icon: LucideIcon;
    onClick?: () => void;
    className?: string;
}

export const LandlordStatCard: React.FC<LandlordStatCardProps> = ({
    title,
    value,
    subtitle,
    icon: Icon,
    onClick,
    className = ''
}) => {
    const baseClasses =
        'bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border rounded-xl shadow-sm hover:shadow-md transition-all cursor-pointer';

    return (
        <button
            type="button"
            onClick={onClick}
            className={`${baseClasses} ${className}`}
        >
            <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                    <div>
                        <p className="text-sm font-medium text-light-subtle dark:text-dark-subtle">
                            {title}
                        </p>
                        <p className="text-3xl font-bold text-light-text dark:text-dark-text">
                            {value}
                        </p>
                    </div>
                    <div className="p-3 rounded-lg bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400">
                        <Icon size={24} />
                    </div>
                </div>
                {subtitle ? (
                    <p className="text-sm text-light-subtle dark:text-dark-subtle">{subtitle}</p>
                ) : null}
            </div>
        </button>
    );
};
